export default __webpack_public_path__ + "static/media/cli-white-martins.50383221.png";